<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <h6 class="m-0">{{ $l('form_header_sales') || '业务人员配置' }}</h6>
      <el-divider direction="vertical" />
      <b-button size="sm" variant="outline-success" @click="addSales">
        {{ $l('btn_addSales') || '新增人员' }}
      </b-button>
    </div>

    <div class="cust-sales-list">
      <el-form
        v-for="(form, index) in listSales"
        :key="index"
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
      >
        <div class="d-flex">
          <div>
            <div>
              <el-avatar
                shape="square"
                :src="form.memImgUrl || defaultAvatar"
              />
            </div>
            <div class="text-center mt-2">
              <el-tooltip
                effect="dark"
                :content="$l('INDEX.btn_tips_del') || '删除'"
                placement="left-end"
              >
                <i
                  class="el-icon-delete text-danger tool-btn"
                  style="font-size: larger;"
                  @click="deleteSales(index)"
                />
              </el-tooltip>
            </div>
          </div>
          <div style="flex:1;padding-left: 16px;">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_userName') || '姓名'"
                  prop="userCode"
                >
                  <dict-select
                    v-model="form.userCode"
                    :placeholder="$l('form_placeholder_user') || '请选择人员'"
                    url="/master/common/dict/baseUserSelect"
                    :selectedLabel.sync="form.userName"
                    clearable
                    filterable
                    size="mini"
                    @change="(code) => userChange(code, index)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$l('form_label_userPost') || '职务'">
                  <el-input v-model="form.userPost" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_mobileNumber') || '联系电话'"
                >
                  <el-input v-model="form.mobileNumber" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_emailAddress') || '邮件地址'"
                >
                  <el-input v-model="form.emailAddress" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_fixedTelephone') || '固定电话'"
                >
                  <el-input v-model="form.fixedTelephone" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$l('form_label_orgName') || '所属公司'">
                  <el-input v-model="form.orgName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('form_label_depFullName') || '所属部门'"
                >
                  <el-input v-model="form.depFullName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_bizTeamRoles') || '业务团队角色'"
                  prop="bizTeamRoles"
                >
                  <dict-select
                    v-model="form.bizTeamRoles"
                    :placeholder="
                      $l('form_placeholder_bizTeamRoles') ||
                        '请选择业务团队角色'
                    "
                    url="/digitalCenter/common/dict/system"
                    :body="{ dictType: 'bizTeamRoles' }"
                    clearable
                    filterable
                    size="mini"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_custCategory') || '负责客户品类'"
                >
                  <dict-select
                    v-model="form.custCategoryCodeList"
                    :placeholder="
                      $l('form_placeholder_custCategory') ||
                        '请选择负责客户品类'
                    "
                    url="/digitalCenter/master/customer/category/select"
                    :body="{ custCode: custCode || 'xxx' }"
                    clearable
                    filterable
                    multiple
                    size="mini"
                    ref="categorySelect"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('form_label_userResponsibilities') || '业务职责说明'
                  "
                >
                  <el-input
                    v-model="form.userResponsibilities"
                    :placeholder="
                      $l('form_placeholder_userResponsibilities') ||
                        '请输入业务职责说明'
                    "
                    type="textarea"
                    maxlength="200"
                    :rows="4"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div style="text-align: center" v-if="!listSales || !listSales.length">
        <img src="/image/static/img/nodata.png" style="width: 120px;" />
        <div class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/api/service'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
const initSales = {
  userPost: '',
  mobileNumber: '',
  emailAddress: '',
  fixedTelephone: '',
  orgName: '',
  depFullName: '',
  memImgUrl: '',
}
export default {
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      listSales: [],
      rules: {
        userCode: [
          {
            required: true,
            message: this.$l('form_placeholder_user') || '请选择人员',
            trigger: 'change',
          },
        ],
        bizTeamRoles: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bizTeamRoles') || '请选择业务团队角色',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  activated() {
    const categorySelect = this.$refs.categorySelect
    if (!categorySelect?.length) return
    categorySelect.forEach((select) => {
      try {
        select.init()
      } catch (e) {
        console.error(e)
      }
    })
  },
  methods: {
    async getData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerBizTeamSetListByCustomerApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.listSales = res.body?.data || []
    },
    addSales() {
      this.listSales.push({ ...initSales })
    },
    async deleteSales(index) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listSales.splice(index, 1)
    },
    async userChange(userCode, index) {
      const getUserInfo = async () => {
        if (!userCode) return {}

        const res = await request({
          url: '/sys/user/detail',
          method: 'POST',
          data: { userCode },
        }).catch(() => null)
        if (!res) return
        return res.body || {}
      }

      const data = await getUserInfo()

      const {
        userPost,
        mobileNumber,
        emailAddress,
        fixedTelephone,
        orgName,
        depFullName,
        memImgUrl,
      } = data

      this.listSales[index].userPost = userPost
      this.listSales[index].mobileNumber = mobileNumber
      this.listSales[index].emailAddress = emailAddress
      this.listSales[index].fixedTelephone = fixedTelephone
      this.listSales[index].orgName = orgName
      this.listSales[index].depFullName = depFullName
      this.listSales[index].memImgUrl = memImgUrl
    },
    validate() {
      return validate.formValidate(this.$refs.form)
    },
    async complete() {
      if (!(await this.validate())) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerBizTeamSetAddUserApi({
          listUser: this.listSales,
          custCode: this.custCode,
          initTeam: true,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return false
      if (res.status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-avatar {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  .cust-sales-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
